import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsString, ValidateNested, IsBoolean, IsOptional } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class Mail {
  @IsNumber()
  @Expose()
  id!: number;
  @IsNumber()
  @Expose()
  mailboxType!: number;
  @IsNumber()
  @Expose()
  recordStampId!: number;
  @IsString()
  @Expose()
  createAt!: string;
  @IsString()
  @Expose()
  recordStampCreateAt!: string;
  @IsString()
  @Expose()
  from!: string;
  @IsString()
  @Expose()
  title!: string;
  @IsBoolean()
  @Expose()
  mailIsPaired!: boolean;
  @IsBoolean()
  @Expose()
  isProcessed!: boolean;
  @Type(() => MailAttachment)
  @ValidateNested()
  @Expose()
  mailAttachments!: Array<MailAttachment>;
}

export class MailAttachment {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  recordLocator!: string;
  @IsString()
  @IsOptional()
  @Expose()
  fileId!: string;
}

export class MailResponse extends GenericTableResponse<Mail> {
  @Expose()
  @IsArray()
  @Type(() => Mail)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<Mail>;
}
